export default "__VITE_ASSET__BZR1IdLU__"